import React, { Fragment } from 'react';
import {Intro, Voiceover, FlipCard} from 'abbot-core';
import img1 from '../../assets/images/U1-T2-2-5a.svg';
import img2 from '../../assets/images/U1-T2-2-5b.svg';
import img3 from '../../assets/images/U1-T2-2-5c.svg';
import img4 from '../../assets/images/U1-T2-2-5d.svg';
import voAudio from '../../assets/vo/U1-T2-2-5.mp3';

const vo = {
  sources: [
    {
      src: voAudio
    }
  ],
  transcript: (
    <p>
      There are times you might have to choose from whatever food is available.  It is important to know how to make the most nutritious food choice possible.
    </p>
  )
};

const data = {
  cards: [
    {
      title: 'Sandwiches',
      frontOfCard: {
        header: 'Sandwiches',
        text: 'Peanut Butter and Jelly or Ham and Cheese',
        image: img1,
        imageText: 'Sandwiches'
      },
      backOfCard: {
        // header: '',
        text: 'You might think that PB&Js are unhealthy because of the sugar in the jelly, but a combination of peanut butter and whole grain bread can provide you with protein, vitamins, fiber, and iron, which give your body the fuel it needs to keep going and helps build strong bones and muscles.  This makes it a healthier choice, because ham contains extremely high levels of sodium and can have high levels of saturated fat.',
        image: img1,
        imageText: 'Sandwiches'
      },
    },
    {
      title: 'Fruit',
      frontOfCard: {
        header: 'Fruit',
        text: 'Apple Slices or 100% Apple Juice',
        image: img2,
        imageText: 'Fruit'
      },
      backOfCard: {
        // header: '',
        text: 'While 100% apple juice might seem like the same thing as an apple, turning fruit into juice takes out the fiber and leaves the sugar. Drinking too much juice can lead to overconsumption of sugar and an increased risk of developing type 2 diabetes. Eating the actual fruit, as part of a healthy diet, can help reduce this risk, making eating the actual fruit a healthier choice.',
        image: img2,
        imageText: 'Fruit'
      },
    },
    {
      title: 'Lunch Choices',
      frontOfCard: {
        header: 'Lunch Choices',
        text: 'Slice of Cheese Pizza or Cheeseburger',
        image: img3,
        imageText: 'Lunch Choices'
      },
      backOfCard: {
        // header: '',
        text: (
          <span>
            While you might think that the cheeseburger is the healthier choice because of its protein, it is important to think about how much fat there is, especially <em>saturated fat</em>. A burger is higher in fat content, making a slice of cheese pizza the healthier choice.
          </span>
        ),
        image: img3,
        imageText: ''
      },
    },
    {
      title: 'Salad Dressing',
      frontOfCard: {
        header: 'Salad Dressing',
        text: 'Italian or Ranch',
        image: img4,
        imageText: 'Salad Dressing'
      },
      backOfCard: {
        // header: '',
        text: 'While you won’t get many nutritional benefits from any salad dressing, vinaigrettes like Italian dressing are better choices than creamy dressings like ranch, because they are lower in calories and unhealthy fats.',
        image: img4,
        imageText: ''
      },
    },
  ]
};

export default {
  title: 'Making Nutritious Food Choices',
  path: '/learn/making-nutritious-food-choices',
  content: (
    <Fragment>
      <Voiceover {...vo} />
      
      <Intro
        title="Making Nutritious Food Choices"
        lead='Look at the food choices provided.  Which would you choose as most nutritious?'
        direction="Flip each card to discover the most nutritious food choice."
      />
      
      <FlipCard
        data={data}
      />
    </Fragment>
  )
};



// WEBPACK FOOTER //
// ./src/data/learn/MakingNutritiousFoodChoices.js